// components/leaders/LeaderHeader.tsx
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";

interface ProfileHeaderProps {
  name: string;
  title: string;
  license?: string;
  location?: string;
}

export default function ProfileHeader({
  name,
  title,
  license,
  location,
}: ProfileHeaderProps) {
  const pathname = usePathname();
  return (
    <>
      <div className="container mx-auto px-4 py-8">
        <Link
          href={
            pathname.includes("careers") ? "/careers/agents" : "/about/leaders"
          }
        >
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            {`Back to ${pathname.includes("careers") ? "Agents" : "Leaders"}`}
          </Button>
        </Link>
      </div>

      <div className="bg-[#E2F3FB] py-12">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-3">{name}</h1>
          <p className="text-xl md:text-2xl text-primary font-medium">
            {title}
          </p>
          {license && (
            <p className="text-base text-muted-foreground mt-3">
              License #: {license}
            </p>
          )}
          {location && (
            <p className="text-base text-muted-foreground mt-1">{location}</p>
          )}
          {name === "Andrea T." && (
            <p className="text-base text-muted-foreground mt-2">
              Se habla español
            </p>
          )}
        </div>
      </div>
    </>
  );
}
